import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UiBlueprintDesignerControllerService } from '../cc-api/services';

@Injectable({
  providedIn: 'root',
})
export class IntentDetailsService {
  private intentData: any;
  private intentFetchingError: any = null;
  private intentMap = new Map<string, any>();
  updateIntentDataSubject = new Subject<boolean>();
  intentLoaded: boolean = false;

  constructor(
    private uiBlueprintDesignerControllerService: UiBlueprintDesignerControllerService,
  ) {}

  setAllIntentData() {
    this.intentLoaded = false;
    this.intentMap = new Map<string, any>();
    this.intentData = null;
    this.intentFetchingError = null;
    return new Promise((resolve, reject) => {
      this.uiBlueprintDesignerControllerService
        .getSchemaMetadataUsingGET()
        .subscribe(
          (intentData: any) => {
            this.intentData = intentData;
            if (intentData?.length) {
              intentData?.forEach((intent) => {
                this.intentMap.set(intent?.intent, intent);
              });
            }
            this.intentLoaded = true;
            this.updateIntentDataSubject.next(true);
            resolve(true);
          },
          (error) => {
            this.intentMap = null;
            this.intentData = null;
            this.intentFetchingError = error;
            this.intentLoaded = true;
            this.updateIntentDataSubject.next(true);
            resolve(true);
          },
        );
    });
  }

  resetData() {
    this.intentMap = null;
    this.intentData = null;
  }

  getIntentDetails(intent) {
    return this.intentMap?.get(intent);
  }

  getAllIntents() {
    return this.intentData;
  }

  getIntentError() {
    return this.intentFetchingError;
  }
}
